import type { Integration, ToolGroup } from "../data/integrations";

function ToolGroupBlock({ group }: { group: ToolGroup }) {
  return (
    <div>
      <div className="flex items-center gap-2.5 mb-2.5 flex-wrap">
        <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-td-1">
          {group.label}
        </div>
        <div className="flex-1 min-w-5 border-t border-dashed border-dash-d" />
        {group.note && (
          <span className="font-mono text-[9px] uppercase tracking-[0.14em] text-warn border border-dashed border-warn rounded-full px-1.5 py-0.5">
            {group.note}
          </span>
        )}
      </div>
      <div className="flex flex-col gap-1.5">
        {group.tools.map((tool) => (
          <div
            key={tool}
            className="flex items-start gap-2.5 text-[14.5px] leading-snug text-td-2"
          >
            <span className="text-accent shrink-0 mt-px">→</span>
            {tool}
          </div>
        ))}
      </div>
    </div>
  );
}

export function IntegrationDetail({
  name,
  integration,
}: {
  name: string;
  integration: Integration;
}) {
  const totalTools = integration.groups.reduce(
    (n, g) => n + g.tools.length,
    0,
  );
  return (
    <div>
      <div className="flex items-baseline gap-3.5 flex-wrap">
        <h3 className="font-display italic font-bold text-[28px] text-td-1 m-0">
          {name}
        </h3>
        <span className="font-mono text-[11px] uppercase tracking-[0.16em] text-accent border border-dashed border-accent rounded-full px-2.5 py-0.5">
          {totalTools} things it can do
        </span>
      </div>
      <p className="mt-2.5 text-base italic leading-relaxed text-td-2">
        {integration.tagline}
      </p>

      <div className="mt-7 flex flex-col gap-4.5">
        {integration.groups.map((group) => (
          <ToolGroupBlock key={group.label} group={group} />
        ))}
      </div>

      <p className="mt-6 text-[13px] italic leading-relaxed text-td-3">
        You decide what your assistant can touch in each tool — and you can
        turn anything off, anytime.
      </p>
    </div>
  );
}
